const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const licensePlateRegex = /^[A-Z]{2}\d{3}[A-Z]{2}$/;
const idCardNumberRegex = /^[A-Z]{2}\d{6}$/;
const dateRegex = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
const yearRegex = /^\d{4}$/;
const postalCityRegex = /^\d{4,5}, .+$/;
const idNumberRegex = /^\d{6}\/?\d{4}$/;

export const validate = {
    required: () => value => !!value,
    any: () => value => true,
    email: () => value => emailRegex.test(value),
    phone: () => value => value.length === 10,
    postalCode: () => value => value.length === 5,
    postalCity: () => value => postalCityRegex.test(value),
    licensePlate: () => value => licensePlateRegex.test(value),
    idCardNumber: () => value => idCardNumberRegex.test(value),
    idNumber: () => value => idNumberRegex.test(value),
    integer: (min, max) => value => !isNaN(parseInt(value)) && parseInt(value) >= min && parseInt(value) <= max,
    date: () => value => dateRegex.test(value),
    year: () => value => yearRegex.test(value),
    and: (l, r) => value => l(value) && r(value),
    or: (l, r) => value => l(value) || r(value),
    not: (r) => value => !r(value),
    cond: (c, t, f) => value => c(value) ? t(value) : f(value),
};
